import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: `0 !important`,

    "& .mat-content": {
      width: "100%",
    },
  },
}));

export const styles = {
  content: {
    width: "292px",
    padding: "0px 20px",
  },
  checkbox: {
    whiteSpace: "nowrap",
  },
  checkboxContainer: {
    width: 20,
    height: 20,
    display: "flex",
    backgroundColor: "events.whiteTertiary",
    borderRadius: "2px",
    border: "1px solid",
    borderColor: "events.grayTertiary",
  },
  checkboxIcon: {
    width: 22,
    height: 22,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
    backgroundColor: "events.blueSecondary",
  },
  header: {
    backgroundColor: "events.grayShade2",
    padding: "20px",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
  },
  saveBtn: {
    width: "112px",
  },
  cancelBtn: {
    width: "127px",
  },
};
